/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import VisitShareButton from "./../../sidebar/VisitShareButton";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import freeCountries from "../../../../utils/freeCountries.json";

const AvatarMenue1 = ({ showSideBarMobile, setShowSideBarMobile }) => {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const orders = useSelector((state) => state.OrdersReducer);
  const worker = useSelector((state) => state.workerReducer);
  const [data, setData] = useState("");
  const [data2, setData2] = useState("");
  const location = useLocation();
  const { t } = useTranslation();
  const dir = i18n.dir();
  const isFreeCountry = freeCountries.includes(account?.country ?? "");
  const currentLang = i18n.language;

  const isRtl = dir === "rtl";

  useEffect(() => {
    setData(account);
    setData2(store);
  }, [account, store]);

  const permissions = worker?.permissions || {};
  const canViewAbndnOrders = permissions["orders.view"] === true;
  const canViewOrders = permissions["orders.view"] === true;
  const canViewProducts = permissions["products.view"] === true;
  const canViewStore = permissions["store.view"] === true;
  const canEditProducts = permissions["products.update"] === true;
  const canEditStore = permissions["store.update"] === true;
  const canEditStoreDesign = permissions["store.updatedesign"] === true;

  const storeName = account?.store?.split(".")[0];
  const domain = `${storeName}.foorweb.online`;
  const digitalStore = useSelector((state) => state.digitalStoreReducer);

  const getLogoSrc = () => {
    const productMode = account?.productMode ?? "classic";

    if (productMode === "classic") {
      return data2?.logo || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    } else if (productMode === "product") {
      return data2?.img || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S"; // هنا كتخدم data2?.img
    } else {
      return digitalStore?.logo || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    }
  };

  const planKeyMap = {
    الأساسية: "basic",
    الاساسية: "basic",
    basic: "basic",

    المتطورة: "advanced",
    advanced: "advanced",

    الأسطورية: "legendary",
    الاسطورية: "legendary",
    legendary: "legendary",
  };
  const planKey = planKeyMap[account?.subscription?.plan];

  return (
    <div className={`${showSideBarMobile ? "block" : "hidden"} md:hidden`}>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-30"
        onClick={() => setShowSideBarMobile(!showSideBarMobile)}
      ></div>

      <aside
        id="mobile-sidebar"
        className={`fixed top-0 z-40 h-screen flex flex-col bg-white w-[280px] shadow-xl ${dir === "rtl" ? "right-0" : "left-0"
          }`}
        aria-label={t("ui.sidebar")}
      >
        <div className="flex-1 overflow-y-auto bg-[#5a2b73] px-0 pb-4 pt-1 sidebarScroll">
          {/* Header */}
          <div className="top-0 right-0 bg-[#5a2b73] pb-3 pr-2 flex">
            <a href="https://foorweb.net/" className="flex items-center">
              <img
                src={
                  currentLang === "ar" ? "/LogoVersionAr.png" : "/logo-new.png" // نفس اللوغو للفرنسية والانجليزية
                }
                className="h-16 sm:h-16"
                alt="Foorweb"
              />
            </a>
          </div>

          <button
            className={`absolute text-[#825ba0] top-7 ${dir === "rtl" ? "left-10" : "right-10"
              }`}
            onClick={() => setShowSideBarMobile(!showSideBarMobile)}
          >
            <i className="bi bi-dash-square-dotted text-2xl"></i>
          </button>

          {/* Profile Section */}
          <div className="p-0 d-flex gap-3 p-sm-2 mr-3">
            <div className="d-flex justify-content-center rounded relative">
              <a
                href="/profile.svg"
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[7px] bg-[#f9c02e] rounded-xl px-2 py-1 text-xs"
              >
                {isFreeCountry
                  ? t("navbar.avatarMenu.free")
                  : planKey
                    ? t(`subscription.plans.${planKey}`)
                    : account?.subscription?.plan}
              </a>
              <img
                src={getLogoSrc()}
                width={65}
                height={65}
                alt={t("ui.profile")}
                className="rounded-[33%] border-2 border-[#f9c02e] border-dashed bg-white"
              />
            </div>

            <div className="d-flex flex-column align-items-center text-white">
              <p className="my-2 text-xl">{data?.name}</p>
              <VisitShareButton
                link={
                  account?.productMode !== "digital" ? account?.store : domain
                }
                isRTL={isRtl}
              />
            </div>
          </div>

          <ul className="space-y-1 mt-[30px] font-medium custom-scrollbar">
            <li
              className={`transition ${location && location.pathname === "/dashboard"
                ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
            >
              <Link
                to={"/dashboard"}
                className={`flex items-center p-2 h-[51px] ${location && location.pathname === "/dashboard"
                  ? "hover:bg-[#52276a]"
                  : "hover:bg-[#52276a]"
                  } group`}
              >
                <div
                  className={`${location && location.pathname === "/dashboard"
                    ? "text-[#dcb5f3]"
                    : "text-[#fff]"
                    }`}
                >
                  <i className="bi bi-speedometer2 mx-sm-3 mx-0 my-auto fs-5" />
                  <span className="">{t("sidebar.dashboard")}</span>
                </div>
              </Link>
            </li>

            {/* Orders - Only if worker has orders.view permission */}
            {canViewOrders &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${location && location.pathname === "/team/orders"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to={"/team/orders"}
                    className={`flex items-center p-2 h-[51px] text-white justify-between ${location && location.pathname === "/team/orders"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location && location.pathname === "/team/orders"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-cart3 mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                      <span>{t("sidebar.orders")}</span>
                    </div>
                    {orders.filter((order) => order.deleveryStatus === "1")
                      .length > 0 && (
                        <span className="inline-flex items-center justify-center px-2 ms-3 text-sm font-medium text-[#5a2b73] bg-[#be97d4] rounded-full pt-1">
                          {
                            orders.filter((order) => order.deleveryStatus === "1")
                              .length
                          }
                        </span>
                      )}
                  </Link>
                </li>
              )}

            {/* Digital Orders */}
            {canViewOrders &&
              digitalStore?.isActiveDigitalProducts &&
              (account?.productMode ?? "classic") !== "classic" && (
                <li
                  className={`transition ${location?.pathname === "/team/orders/digital"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to="/team/orders/digital"
                    className={`flex items-center p-2 h-[51px] text-white justify-between ${location?.pathname === "/team/orders/digital"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location?.pathname === "/team/orders/digital"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-cart3 mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                      <span>{t("sidebar.digitalOrders")}</span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Abandoned Orders */}
            {canViewOrders && worker.role == "partner" &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${location && location.pathname === "/team/Ordersabndn"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to={"/team/Ordersabndn"}
                    className={`flex items-center p-2 h-[51px] text-white justify-between ${location && location.pathname === "/team/Ordersabndn"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location && location.pathname === "/team/Ordersabndn"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-cart-x-fill mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                      <span>{t("sidebar.abndndOrders")}</span>
                    </div>
                    {orders.filter((order) => order.deleveryStatus === "20")
                      .length > 0 && (
                        <span className="inline-flex items-center justify-center px-2 ms-3 text-sm font-medium text-[#5a2b73] bg-[#be97d4] rounded-full pt-1">
                          {
                            orders.filter(
                              (order) => order.deleveryStatus === "20"
                            ).length
                          }
                        </span>
                      )}
                  </Link>
                </li>
              )}

            {/* Products */}
            {canViewProducts && (
              <li
                className={`transition ${location && location.pathname === "/team/products"
                  ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                  : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
              >
                <Link
                  to={"/team/products"}
                  className={`flex items-center p-2 h-[51px] text-white justify-between ${location && location.pathname === "/team/products"
                    ? "hover:bg-[#52276a]"
                    : "hover:bg-[#52276a]"
                    } group`}
                >
                  <div
                    className={`${location && location.pathname === "/team/products"
                      ? "text-[#dcb5f3]"
                      : "text-[#fff]"
                      }`}
                  >
                    <i className="bi bi-box-seam mx-sm-3 mx-0 fs-5 my-auto" />
                    <span className="flex-1 whitespace-nowrap">
                      {t("sidebar.products")}
                    </span>
                  </div>
                </Link>
              </li>
            )}

            {/* Store Customization - Classic */}
            {canEditStore && canEditStoreDesign &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${location && location.pathname === "/team/settings/store"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to={`/team/settings/store`}
                    className={`flex items-center p-2 h-[51px] text-white ${location && location.pathname === "/team/settings/store"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location && location.pathname === "/team/settings/store"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-palette mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.storeCostumisation")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Store Customization - Digital */}
            {canViewStore &&
              (account?.productMode ?? "classic") === "digital" && (
                <li
                  className={`transition ${location &&
                    location.pathname === "/team/digital/settings/store"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to={`/team/digital/settings/store`}
                    className={`flex items-center p-2 h-[51px] text-white ${location &&
                      location.pathname === "/team/digital/settings/store"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location &&
                        location.pathname === "/team/digital/settings/store"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-palette mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.storeCostumisation")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Stock */}
            {canEditProducts &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${location && location.pathname === "/team/settings/stock"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to={`/team/settings/stock`}
                    className={`flex items-center p-2 h-[51px] text-white ${location && location.pathname === "/team/settings/stock"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location && location.pathname === "/team/settings/stock"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-collection mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.stock")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Payment Methods - Digital */}
            {canViewStore &&
              (account?.productMode ?? "classic") !== "classic" && (
                <li
                  className={`transition ${location && location.pathname === "/payment-methods"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to={`/payment-methods`}
                    className={`flex items-center p-2 h-[51px] text-white ${location && location.pathname === "/payment-methods"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location && location.pathname === "/payment-methods"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-credit-card mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.paimentMethods")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Digital Sections */}
            {canViewStore &&
              (account?.productMode ?? "classic") !== "classic" && (
                <li
                  className={`transition ${location && location.pathname === "/digital-sections"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                    }`}
                >
                  <Link
                    to={`/digital-sections`}
                    className={`flex items-center p-2 h-[51px] text-white ${location && location.pathname === "/digital-sections"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                      } group`}
                  >
                    <div
                      className={`${location && location.pathname === "/digital-sections"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                        }`}
                    >
                      <i className="bi bi-folder-fill mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.digitalSections")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

          </ul>

          {/* Mobile Apps */}
          <div className="px-4 pt-6 pb-2 border-t border-[#6d3a88]">
            <h4 className="text-white text-sm font-medium mb-3 text-center">
              {t("sidebar.doxnload")}
            </h4>
            <div className="flex justify-center space-x-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.foorweb.foorwebapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/googlePlay.png"
                  alt={t("AccountSettings.twoFA.steps.downloadApp.buttons.googlePlay")}
                  className="h-10"
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/foorweb/id6738890253"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/appStore.png"
                  alt={t("AccountSettings.twoFA.steps.downloadApp.buttons.appStore")}
                  className="h-10"
                />
              </a>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default AvatarMenue1;
